<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_5",
      next: "P_7",
      topic: "Taller ¿Qué es crédito? / ¡Estoy listo para cursar esta lección!",
      dialog: false,
      correcta: false,
      respuesta: "none",
      sent: false,
      resultado: 0
    };
  },
  methods: {
    sendResult() {
      if (this.correcta == this.respuesta) {
        this.resultado = 1;
      }
      this.sent = true;
      eventBus.$emit("send_result", this.resultado);
      eventBus.$emit("send_suspend_data", this.respuesta);
    }
  },
  created() {
    if ("suspend_data" in this.$parent) {
      if (this.$parent.currentPage in this.$parent.suspend_data) {
        this.respuesta = this.$parent.suspend_data[this.$parent.currentPage];
        this.sendResult();
      }
    }
  },
  computed: {
    responseIsNone() {
      return {
        "btn-primary": this.respuesta != "none",
        "btn-secondary": this.respuesta == "none"
      };
    }
  }
};
</script>

<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(:back='last') Estás en: {{topic}}
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B ') PREGUNTA 5 DE 5
            v-card-text.titulo24Reg
              | La tasa de interés es uno de los elementos primordiales a considerar para contratar cualquier tipo de crédito. 
            v-card-text.parrafoDestacadoB.text-center  ¿Qué opinas sobre la siguiente afirmación? 
            v-card.questionCard(justify-center, flat)
              v-card-text.titulo18Book.text-center
                | La tasa de interés es el porcentaje que cobra el banco para garantizar que le vas a pagar. ¿Cierto o falso? 
              v-layout.py-0.my-0(row, justify-center)
                v-flex(xs8, sm6, md4, offset-xs1, justify-center)
                  v-radio-group(v-model='respuesta ', row)
                    v-radio.pt-0.px-4(color='primary ', :label='`Cierto` ', :value='true ')
                    div(v-if='sent && (respuesta==true) ')
                      v-icon(size='15px', color='red ') fas fa-times
                    v-radio.pt-0.px-4(color='primary ', :label='`Falso` ', :value='false ')
                    div(v-if='sent && (respuesta==false) ')
                      v-icon.mb-1(size='15px', color='green') fas fa-check
            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false ')
                  v-btn.btn(color='secondary ', v-bind:class='responseIsNone ', :disabled="respuesta=='none' ", @click='sendResult() ')
                    | Enviar
                div(v-if='sent ')
                  v-btn.btn(color='accent ', style='z-index:2', @click.prevent='dialog=true ')
                    | Retroalimentación
                  v-dialog(v-model='dialog ', persistent, max-width='930px ', content-class="dialog_over")
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card.pb-4
                          div(v-if='sent && (respuesta==false) ')
                            v-layout(v-if='dialog ')
                              v-flex(text-xs-center)
                                img.dialog_img(src='@/assets/ManoOk.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Tienes toda la razón! 
                            v-card.questionCard(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5
                                  | La tasa de interés no es el porcentaje que cobra el banco para garantizar que le vas a pagar. Eso es falso.  
                                p.text-sm-left.px-5
                                  | En realidad, la tasa de interés es el porcentaje que el banco cobra por financiar tu deuda.                         
                          div(v-if='sent && (respuesta==true) ')
                            v-layout(v-if='dialog ')
                              v-flex(text-xs-center)
                                img.dialog_img(src='@/assets/ManoStop.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¿Estás seguro? 
                            v-card.questionCard(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5
                                  | Considera que al otorgarte cualquier tipo de crédito, el banco confía en que le vas a pagar y, por lo tanto, es falso que la tasa de interés sea el porcentaje que cobra el banco para garantizar que le vas pagar. 
                                p.text-sm-left.px-5
                                  | En realidad, la tasa de interés es el porcentaje que el banco cobra por financiar tu deuda.
                          v-btn.btn.dialog_btn(color='accent ', @click.prevent="nextPage(next)")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>


